import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { deleteH24Rate, fetchH24Rates, importH24Rates, postH24Rate } from '../../../../../api/h24Api/h24Rates'
import { selectCurrentOrganization } from '../../../../../selectors/hotels24Selectors/h24CurrentOrganization'
import { selectEasymsRatesKV } from '../../../../../selectors/hotels24Selectors/h24EasymsSelector'
import { selectRates, selectRatesFetching } from '../../../../../selectors/hotels24Selectors/h24Rates'
import RatesTable from './RatesTable'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class RatesTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        rates: PropTypes.array.isRequired,
        easymsRatesKV: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchH24Rates: PropTypes.func.isRequired,
        postH24Rate: PropTypes.func.isRequired,
        deleteH24Rate: PropTypes.func.isRequired,
        importH24Rates: PropTypes.func.isRequired
    }

    state = {
        ourId: '',
        remoteId: ''
    }

    componentDidMount() {
        const params = { organizationId: this.props.currentOrganization }
        this.props.fetchH24Rates(params)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentOrganization !== this.props.currentOrganization) {
            const params = { organizationId: this.props.currentOrganization }
            this.props.fetchH24Rates(params)
            this.setState({ ourId: '' })
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleClick = () => {
        const { ourId, remoteId } = this.state
        this.props.postH24Rate({
            organizationId: this.props.currentOrganization,
            ourId,
            remoteId: remoteId.trim()
        })
        this.setState({
            ourId: '',
            remoteId: ''
        })
    }

    handleDelete = remoteId => {
        this.props.deleteH24Rate(remoteId)
    }

    handleUpdate = rate => {
        this.props.postH24Rate({
            organizationId: this.props.currentOrganization,
            ourId: rate.ourId,
            remoteId: rate.remoteId
        })
    }

    handleLoadImport = () => {
        this.props.importH24Rates()
    }

    render() {
        const { classes, fetching, rates, currentOrganization, easymsRatesKV } = this.props
        const { ourId, remoteId } = this.state

        const valid = ourId && remoteId.trim()

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TextField
                        select
                        label="Тариф EasyMS"
                        className={classes.formControl}
                        value={ourId}
                        onChange={this.handleSelect('ourId')}
                    >
                        {easymsRatesKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="rates-remote-id">ID тарифа Hotels24.ua</InputLabel>
                        <Input id="rates-remote-id" name="remoteId" value={remoteId} onChange={this.handleChange} />
                    </FormControl>

                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Сохранить
                    </Button>
                </Paper>

                <Button
                    disabled={!currentOrganization}
                    variant="raised"
                    color="primary"
                    className={classes.button}
                    onClick={this.handleLoadImport}
                >
                    Импортировать тарифы с Hotels24.ua
                </Button>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <RatesTable rates={rates} onDelete={this.handleDelete} onUpdate={this.handleUpdate} />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        rates: selectRates(state),
        fetching: selectRatesFetching(state),
        currentOrganization: selectCurrentOrganization(state),
        easymsRatesKV: selectEasymsRatesKV(state)

    }),
    { fetchH24Rates, postH24Rate, deleteH24Rate, importH24Rates }
)(withStyles(styles)(RatesTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/RatesTab/RatesTab.js